import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { INavigation } from '@core/models';
import { Page } from '@core/services';
import { CdnUrlPipe } from '@shared/pipes';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MainNavigation } from '../main-navigation/main-navigation';
import { RouterModule } from '@angular/router';

/**
 * ### **MainHeaderComponent**
 *
 * Componente encargado de renderizar la cabecera principal, en esta se encontrara el logo y el menu de navegación.
 **/
@Component({
  selector: 'app-main-header',
  imports: [LazyLoadImageModule, CdnUrlPipe, MainNavigation, RouterModule],
  templateUrl: './main-header.html',
  styleUrl: './main-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainHeader {
  private readonly pageService = inject(Page);

  /** Variable que recibe datos de un componente externo, mas específico de el tamaño de la imagen, en caso de no llegar un valor de le da un valor por defecto */
  readonly width = input<string>('200px');

  /** Variable que recibe datos de un componente externo, mas especifico un Arreglo de tipo {@link INavigation}*/
  readonly navigation = input<INavigation[]>([]);

  /** Variable that stores the logo image */
  protected readonly image = computed<string>(() => {
    const signalHome = this.pageService.signalHome();
    if (!signalHome) return '';
    return signalHome.home.logo;
  });

  /** Variable de tipo boolean que define el comportamiento del botón que visualizará el menú en los dispositivos moviles  */
  protected readonly toggleNavbar = signal<boolean>(false);

  /**
   * Función que se encarga de cerrar el menu de navegación en dispositivos menosres a 768px
   */
  protected toggle() {
    if (window.innerWidth <= 995) {
      this.toggleNavbar.update((value) => !value);
    }
  }
}
